$(document).ready(function () {
    $('div[class*="question-icon-"]').on('click', function (event) {
        event.stopPropagation();
        event.stopImmediatePropagation();

        // show answer on click
        $(this).siblings($('.answer')).toggle();
        // toggle class on click
        $(this).children().closest($('.question')).toggleClass('question-active');
        $(this).children().closest($('.open-close-icon')).toggleClass('open-close-icon-active');
    });

    // show general
    $('.general, .opt-general').on('click', function () {
        $('.general').addClass('active');
        $('.general-faqs-content').show();
        $('.orders-faqs-content').hide();
        $('.orders').removeClass('active');
        $('.shipping-faqs-content').hide();
        $('.shipping').removeClass('active');
        $('.my-account-faqs-content').hide();
        $('.account').removeClass('active');
        // title dropdown
        $('.dropdown-select').html('General');
    });
    $('.opt-general').on('click', function () {
        // toggle mobile menu
        $('.faqs-dropdown-options').toggle();
    });

    // show orders
    $('.orders, .opt-orders').on('click', function () {
        $('.orders').addClass('active');
        $('.general-faqs-content').hide();
        $('.general').removeClass('active');
        $('.orders-faqs-content').show();
        $('.shipping-faqs-content').hide();
        $('.shipping').removeClass('active');
        $('.my-account-faqs-content').hide();
        $('.account').removeClass('active');
        // title dropdown
        $('.dropdown-select').html('Orders');
    });
    $('.opt-orders').on('click', function () {
        // toggle mobile menu
        $('.faqs-dropdown-options').toggle();
    });

    // show shipping
    $('.shipping, .opt-shipping').on('click', function () {
        $('.shipping').addClass('active');
        $('.general-faqs-content').hide();
        $('.general').removeClass('active');
        $('.orders-faqs-content').hide();
        $('.orders').removeClass('active');
        $('.shipping-faqs-content').show();
        $('.my-account-faqs-content').hide();
        $('.account').removeClass('active');
        // title dropdown
        $('.dropdown-select').html('Shipping');
    });
    $('.opt-shipping').on('click', function () {
        // toggle mobile menu
        $('.faqs-dropdown-options').toggle();
    });

    // show shipping
    $('.account, .opt-account').on('click', function () {
        $('.account').addClass('active');
        $('.general-faqs-content').hide();
        $('.general').removeClass('active');
        $('.orders-faqs-content').hide();
        $('.orders').removeClass('active');
        $('.shipping-faqs-content').hide();
        $('.shipping').removeClass('active');
        $('.my-account-faqs-content').show();
        // title dropdown
        $('.dropdown-select').html('Account');
    });
    $('.opt-account').on('click', function () {
        // toggle mobile menu
        $('.faqs-dropdown-options').toggle();
    });

    // dropdown toggle
    $('.faqs-down-arrow').on('click', function (event) {
        event.stopPropagation();
        event.stopImmediatePropagation();
        console.log('clicked');

        $('.faqs-dropdown-options').toggle();
    });

    // search questions
    $('#faqs-search').on('keyup', function (evt) {
        let search = evt.target.value;
        // console.log('Here is your search: ', search);
        // call to route and return results
        $.ajax({
            type: 'GET',
            url: `faqs-search/${search}`,
            // data: search,
            success: function (res) {
                if (res) {
                    let questionAnswersSearchRes = res.results;
                    $('.general-section').hide();
                    $('.search-result-section').show();

                    console.log('Here are your search results: ', res);
                    $('.search-results').empty(); //Clear results
                    questionAnswersSearchRes.forEach(addToResults);
                } else {
                }
                function addToResults(item) {
                    // console.log(item);
                    let resultDiv1 = "<div class='question'>" + item.question + '</div>';
                    let resultDiv2 = "<div class='answer'>" + item.answer + '</div>';
                    $('.search-results').append(resultDiv1, resultDiv2);
                }
            },
            error: function (err) {
                if (err) {
                    $('.search-result-section').hide();
                    $('.general-section').show();
                }
            },
        });
    });
});
